"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = require("react");
var KEYCODE_TAB = 9;
function isTabKey(e) {
  return e.key === 'Tab' || e.keyCode === KEYCODE_TAB;
}
function doDefaultTabEvent(e, tabables) {
  var _document = document,
    activeElement = _document.activeElement;
  var first = tabables[0];
  var last = tabables[tabables.length - 1];
  if (isTabKey(e)) {
    if (e.shiftKey) {
      if (activeElement === first) {
        /* shift + tab */
        last.focus();
        e.preventDefault();
      }
    } else if (activeElement === last) {
      /* tab */
      first.focus();
      e.preventDefault();
    }
  }
}
var useFocusTrap = function useFocusTrap(dependencies) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref$initialTarget = _ref.initialTarget,
    initialTarget = _ref$initialTarget === void 0 ? null : _ref$initialTarget,
    _ref$refreshAlways = _ref.refreshAlways,
    refreshAlways = _ref$refreshAlways === void 0 ? true : _ref$refreshAlways,
    _ref$tabablesSelector = _ref.tabablesSelector,
    tabablesSelector = _ref$tabablesSelector === void 0 ? '' : _ref$tabablesSelector,
    _ref$tabIndexOnly = _ref.tabIndexOnly,
    tabIndexOnly = _ref$tabIndexOnly === void 0 ? true : _ref$tabIndexOnly;
  var _useState = (0, _react.useState)(initialTarget),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    target = _useState2[0],
    _setTarget = _useState2[1];
  function isTargetTabable() {
    var _target$attributes$ta;
    return ((_target$attributes$ta = target.attributes.tabindex) === null || _target$attributes$ta === void 0 ? void 0 : _target$attributes$ta.value) >= 0;
  }
  function getSelector() {
    var finalSelector = tabablesSelector;
    if (!finalSelector) {
      var notDisabled = ':not([disabled])';
      if (!tabIndexOnly) {
        finalSelector = ['[tabindex]', 'button', 'input', 'textarea', 'select', 'object'].join(':not([disabled]),');
      } else {
        finalSelector = '[tabindex]';
      }
      finalSelector += notDisabled;
    }
    return finalSelector;
  }
  function getTabablesHelper() {
    var tabables = [];
    // Get elements that can be tabbed
    if (isTargetTabable() && !target.disabled) {
      tabables = [target]; // Add parent to tabables
    }

    target.querySelectorAll(getSelector()).forEach(function (t) {
      if (!t.attributes.tabindex || t.attributes.tabindex.value >= 0) {
        tabables.push(t);
      }
    });
    return tabables;
  }
  (0, _react.useEffect)(function () {
    var onTabEvent;
    var resetFocus;
    var resetTargetFocus;
    var curTabables = [];
    function getTabables() {
      if (refreshAlways) {
        curTabables = getTabablesHelper();
      }
      return curTabables;
    }
    if (target) {
      resetFocus = function resetFocus(tabables) {
        var _document2 = document,
          activeElement = _document2.activeElement;

        // If the target doesn't have, focus on the first tabable
        if (tabables[0]) {
          if (!isTargetTabable() && target === activeElement || !target.contains(activeElement)) {
            tabables[0].focus();
          }
        }
      };

      // Add the event listener to override the default tab behavior
      onTabEvent = function onTabEvent(e) {
        doDefaultTabEvent(e, getTabables());
      };
      resetTargetFocus = function resetTargetFocus() {
        resetFocus(getTabables());
      };
      target.addEventListener('keydown', onTabEvent);
      // Refocus on a tabable if a click event blurs it
      target.addEventListener('click', resetTargetFocus);

      // Reset the focus if it is lost after a state update
      resetTargetFocus();
    }

    // Clean up
    return function () {
      if (target) {
        target.removeEventListener('keydown', onTabEvent);
        target.removeEventListener('click', resetTargetFocus);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [].concat((0, _toConsumableArray2["default"])(dependencies || []), [target]));
  return {
    target: target,
    setTarget: function setTarget(t) {
      _setTarget(t);
    },
    focus: function focus() {
      if (getTabablesHelper()[0]) {
        getTabablesHelper()[0].focus();
      }
    }
  };
};
var _default = useFocusTrap;
exports["default"] = _default;
//# sourceMappingURL=useFocusTrap.js.map